import * as React from 'react';
import { Route, Routes } from 'react-router-dom';
import { Four04 } from 'gossamer-front-end';
import { BookingExport } from './BookingExport';
import { BookingSearch } from './BookingSearch';
import { EventSearch } from './EventSearch';
import { GroupWeekSearch } from './GroupWeekSearch';
import { GroupWeekUserSearch } from './GroupWeekUserSearch';
import { InstitutionWeekSearch } from './InstitutionWeekSearch';
import { MetricsDisplay } from './MetricsDisplay';
import { UserWeekSearch } from './UserWeekSearch';

export const ReportingRoutes = (): React.JSX.Element => (
  <Routes>
    <Route path="/booking-export" element={<BookingExport />} />
    <Route path="/booking-search" element={<BookingSearch />} />
    <Route path="/event-search" element={<EventSearch />} />
    <Route path="/group-week-search" element={<GroupWeekSearch />} />
    <Route path="/group-week-user-search" element={<GroupWeekUserSearch />} />
    <Route path="/inst-week-search" element={<InstitutionWeekSearch />} />
    <Route path="/user-week-search" element={<UserWeekSearch />} />
    <Route path="/metrics" element={<MetricsDisplay />} />
    <Route path="*" element={<Four04 />} />
  </Routes>
);
